import { FormattedMessage } from 'react-intl';

import { Link } from '@mui/material';

import { CONFIG } from '@arrived/config';

import { PreRenderedFormattedMessageProps } from './PreRenderedFormattedMessageProps';

export const AwaitingValuationDescription = (props: PreRenderedFormattedMessageProps) => (
  <FormattedMessage
    id="awaiting-valuation-description"
    defaultMessage="Share Price values are updated 6 months after initial property funding at the next quarterly update. After that point share prices are updated each quarter going forward. <a>Check out this article on how share prices are calculated.</a>"
    values={{
      a: (parts: any) => (
        <Link
          fontSize="inherit"
          href={`${CONFIG.helpUrl}/articles/6909386-how-are-share-prices-calculated`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {parts}
        </Link>
      ),
    }}
    {...props}
  />
);
